var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCountCollateData01 = function SvgCountCollateData01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "count_collate_data-01_svg2__a",
    x1: 2.24,
    x2: 198.76,
    y1: 178.91,
    y2: 43.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#count_collate_data-01_svg2__a",
    id: "count_collate_data-01_svg2__b",
    x1: -13.94,
    x2: 182.58,
    y1: 155.45,
    y2: 19.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#count_collate_data-01_svg2__a",
    id: "count_collate_data-01_svg2__c",
    x1: -35.84,
    x2: 160.68,
    y1: 123.69,
    y2: -11.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#count_collate_data-01_svg2__a",
    id: "count_collate_data-01_svg2__d",
    x1: 9.12,
    x2: 205.64,
    y1: 188.88,
    y2: 53.35
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M190 40h-30V30c0-5.51-4.49-10-10-10h-30V10c0-5.51-4.49-10-10-10H43.34c-2.76 0-5.26 1.12-7.07 2.93C34.46 4.75 2.93 36.26 2.93 36.26A9.97 9.97 0 0 0 0 43.33V150c0 5.51 4.49 10 10 10h30v10c0 5.51 4.49 10 10 10h30v10c0 5.51 4.49 10 10 10h100c5.51 0 10-4.49 10-10V50c0-5.51-4.49-10-10-10M33.34 15.29V30c0 1.84-1.5 3.33-3.33 3.33H15.3l18.05-18.05ZM10 153.33c-1.84 0-3.33-1.49-3.33-3.33V43.33C6.67 41.49 8.17 40 10 40h20c5.51 0 10-4.49 10-10V10c0-1.84 1.5-3.33 3.33-3.33H110c1.84 0 3.33 1.49 3.33 3.33v140c0 1.84-1.49 3.33-3.33 3.33zm40 20c-1.84 0-3.33-1.49-3.33-3.33v-10H110c5.51 0 10-4.49 10-10V26.67h30c1.84 0 3.33 1.49 3.33 3.33v140c0 1.84-1.49 3.33-3.33 3.33zM193.34 190c0 1.84-1.49 3.33-3.33 3.33h-100c-1.84 0-3.33-1.49-3.33-3.33v-10h63.33c5.51 0 10-4.49 10-10V46.67h30c1.84 0 3.33 1.49 3.33 3.33z",
    style: {
      fill: "url(#count_collate_data-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.67 43.33c0-5.51-4.49-10-10-10s-10 4.49-10 10c0 1.84 1.49 3.33 3.33 3.33s3.33-1.49 3.33-3.33 1.49-3.33 3.33-3.33 3.33 1.49 3.33 3.33c0 3.98-3.16 6.71-6.52 9.6-3.35 2.89-6.82 5.88-6.82 10.4 0 1.84 1.49 3.33 3.33 3.33h13.33c1.84 0 3.33-1.49 3.33-3.33S145.15 60 143.31 60h-7.76c.7-.66 1.49-1.35 2.27-2.02 3.94-3.39 8.83-7.61 8.83-14.65Z",
    style: {
      fill: "url(#count_collate_data-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.34 40h-3.33V16.67c0-1.35-.81-2.57-2.06-3.08a3.32 3.32 0 0 0-3.63.72l-6.67 6.67a3.332 3.332 0 0 0 4.71 4.71l.98-.98V40h-3.33c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h13.33c1.84 0 3.33-1.49 3.33-3.33S105.18 40 103.34 40",
    style: {
      fill: "url(#count_collate_data-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.67 56.66c-5.51 0-10 4.49-10 10 0 1.84 1.49 3.33 3.33 3.33s3.33-1.49 3.33-3.33 1.49-3.33 3.33-3.33 3.33 1.49 3.33 3.33c0 2.56-1.8 3.28-2.29 3.43-1.46.36-2.47 1.67-2.5 3.18s.99 2.86 2.44 3.28c.55.16 2.35.89 2.35 3.45 0 1.84-1.49 3.33-3.33 3.33s-3.33-1.49-3.33-3.33-1.49-3.33-3.33-3.33-3.33 1.49-3.33 3.33c0 5.51 4.49 10 10 10s10-4.49 10-10c0-2.91-1-5.09-2.32-6.67 1.33-1.57 2.32-3.76 2.32-6.67 0-5.51-4.49-10-10-10",
    style: {
      fill: "url(#count_collate_data-01_svg2__d)"
    }
  }));
};
export default SvgCountCollateData01;